export default __webpack_public_path__ + "static/media/logo-dashboard.928c7b14.png";